import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TabsComponent } from '../../components/tabs/tabs.component';
import { DictionaryService } from '../../services/dictionary.service';
import { Route } from '../../utils/route';
import { SalesBricksTabComponent } from './sales-bricks-tab/sales-bricks-tab.component';
import { SalesCustomersTabComponent } from './sales-customers-tab/sales-customers-tab.component';
import { SalesProductsTabComponent } from './sales-products-tab/sales-products-tab.component';
import { SalesSheetTabComponent } from './sales-sheet-tab/sales-sheet-tab.component';

@Component({
  selector: 'app-sales',
  imports: [
    TabsComponent,
    SalesSheetTabComponent,
    SalesProductsTabComponent,
    SalesBricksTabComponent,
    SalesCustomersTabComponent,
  ],
  templateUrl: './sales.component.html',
  styleUrl: './sales.component.scss',
})
export class SalesComponent extends Route implements OnInit {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly dictionaryService = inject(DictionaryService);

  private readonly salesTabs = [
    { key: 'SalesSheets', param: 'sheets' },
    { key: 'Products', param: 'products' },
    { key: 'Bricks', param: 'bricks' },
    { key: 'Customers', param: 'customers' },
  ] as const;

  readonly defaultTab = signal<string>('');

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      const tabParam = String(params['tab'] || '').toLowerCase();
      const tab = this.salesTabs.find(({ param }) => param === tabParam);

      this.defaultTab.set(
        tab ? this.dictionaryService.get(tab.key) : '',
      );
    });
  }

  onTabChange(tabLabel: string): void {
    const tab = this.salesTabs.find(
      ({ key }) => this.dictionaryService.get(key) === tabLabel,
    );

    if (!tab) return;

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { tab: tab.param },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }
}
